import React, { useEffect, useState } from 'react';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { usePatientMutation } from "~/api/patient/usePatientMutation";
import { CachedOutlined } from "@mui/icons-material";
import "@fontsource/lato";
import { useQueryClient } from 'react-query';
export const PatientReportFollowUpDate = (props) => {
    const { patient } = props;
    const [selectedDate, setSelectedDate] = React.useState(dayjs(new Date()));
    const [followUpDateColor, setFollowUpDateColor] = useState('#2C78EB');
    const [followUpText, setFollowUpText] = useState('');
    const [openFollowUpCalendar, setOpenFollowUpCalendar] = useState(false);
    const { mutateAsync } = usePatientMutation();
    const queryClient = useQueryClient();
    const clearFollowUpDate = async () => {
        const patientId = patient.id;
        await mutateAsync({ patientId, followUp: 'null' });
        setSelectedDate(null);
        setFollowUpDateColor('#2C78EB');
        setFollowUpText('');
        patient.followUp = null;
        queryClient.invalidateQueries(['getPatientTimeline', patient.id]);
    };
    const updateFollowUpDate = async (value) => {
        const patientId = patient.id;
        await mutateAsync({ patientId, followUp: value.format('YYYY-M-D').toString() });
        updateFollowUpText(value);
        patient.followUp = new Date(value.format('YYYY-M-D').toString());
        queryClient.invalidateQueries(['getPatientTimeline', patient.id]);
    };
    const updateFollowUpText = (value) => {
        const today = dayjs().format('YYYY-M-D');
        if (value.isSame(today)) {
            setFollowUpDateColor('#42A5F5');
            setFollowUpText('Today');
        }
        if (value.isAfter(today)) {
            setFollowUpDateColor('#00000099');
            setFollowUpText('Pending');
        }
        if (value.isBefore(today)) {
            setFollowUpDateColor('#EF5350');
            setFollowUpText('Past Due');
        }
    };
    useEffect(() => {
        if (patient.followUp) {
            setSelectedDate(dayjs(patient.followUp));
            updateFollowUpText(dayjs(patient.followUp));
        }
        else {
            setSelectedDate(null);
        }
    }, []);
    return (React.createElement("div", null,
        React.createElement("div", { style: { width: '100%', marginBottom: '10px', textAlign: 'left' } },
            React.createElement("span", { style: { color: '#00000099', fontSize: 12, fontFamily: 'Barlow', fontWeight: '500', marginRight: '5px' } }, "Follow-Up:"),
            React.createElement("span", { style: { color: followUpDateColor, fontSize: 12, fontFamily: 'Barlow', fontWeight: '500' } }, followUpText)),
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: '8px' } },
            React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
                React.createElement(DatePicker, { open: openFollowUpCalendar, onOpen: () => setOpenFollowUpCalendar(true), onClose: () => setOpenFollowUpCalendar(false), slotProps: {
                        textField: {
                            size: 'small',
                            onClick: () => setOpenFollowUpCalendar(true),
                        },
                    }, label: '', value: selectedDate, minDate: dayjs(), onChange: (value) => {
                        updateFollowUpDate(dayjs(value));
                        setSelectedDate(value);
                    } })),
            React.createElement("span", null,
                React.createElement(CachedOutlined, { style: { visibility: selectedDate ? 'visible' : 'hidden', float: 'right', cursor: 'pointer' }, color: 'primary', onClick: () => { if (selectedDate)
                        clearFollowUpDate(); } })))));
};
